import ApiConstants from "../constants/ApiConstants";
import http from "../http";
import { TENANT, TenantService } from "../managers/TenantManagerService";
import Utility from "../utility/Utility";
import axios from "axios";

export const EXPENSE_CONSTANTS = {
    DRAFT: 'DRAFT',
    PENDING: 'PENDING',
    APPROVED: 'APPROVED',
    APPROVE: "APPROVE",
    REJECT: "REJECT",
    DUPLICATE: "DUPLICATE",
    SUBMITTED: "SUBMITTED",
    DELETE: "DELETE",
    PRINT: "PRINT",
    EDIT_GROUP_NAME: "EDIT_GROUP_NAME",
    EXPENSE_PAY:"PAY_WITH_CHECK",
    EXPENSE_PAYPAL_PAY: "PAY_WITH_PAYPAL",
    EDIT: "EDIT"

}

export interface ExpenseClaimsListAPIConfig {
    params?: Object;
    queryParams?: Object;
}

const defaultConfig: ExpenseClaimsListAPIConfig = {
    params: {
        view: "EMPLOYEE",
        limit: 20,
        page: 0
    },
    queryParams: {}
};

class ExpenseClaimListService {
    static activeTab = null;
    static apiConfig: ExpenseClaimsListAPIConfig;

    static fetchExpenses() {
        if (Utility.isEmpty(this.apiConfig)) {
            this.apiConfig = defaultConfig;
        }

        const queryParams = [];
        Object.keys(this.apiConfig.queryParams).map(param => queryParams.push(`${param}${this.apiConfig.queryParams[param]}`));

        return http.get(`${ApiConstants.URL.BASE}${ApiConstants.URL.EXPENSE.GET_EXPENSES}?query=${queryParams.join(',')}`, { params: this.apiConfig.params }).catch(
            (error) => {
                console.error('Error fetching expenses: ', error);
                return Promise.reject(error);
            }
        );
    }

    static fetchCategories() {
        const URL = TenantService.get(TENANT.IS_ADMIN) ? `${ApiConstants.URL.BASE}${ApiConstants.URL.EXPENSE.CATEGORY}` : `${ApiConstants.URL.BASE}${ApiConstants.URL.EXPENSE.GET_CATEGORY}`;
        return http.get(URL).catch(
            (error) => {
                console.error('Error fetching categories: ', error);
                return Promise.reject(error);
            }
        );
    }

    static fetchTaxes() {
        return http.get(`${ApiConstants.URL.BASE}${ApiConstants.URL.EXPENSE.TAXES}`).catch(
            (error) => {
                console.error('Error fetching taxes: ', error);
                return Promise.reject(error);
            }
        );
    }

    static approveOrRejectClaims(payload, params) {
        return http.post(`${ApiConstants.URL.BASE}${ApiConstants.URL.EXPENSE.APPROVE_EXPENSE}`, payload, { params: params }).catch(
            (error) => {
                console.error('Error approve/reject expense: ', error);
                return Promise.reject(error);
            }
        );
    }

    static deleteExpense(id) {
        return http.delete(`${ApiConstants.URL.BASE}${ApiConstants.URL.EXPENSE.EXPENSES}/${id}`).catch(
            (error) => {
                console.error('Error deleting expense: ', error);
                return Promise.reject(error);
            }
        );
    }

    static submitExpense(id, payload) {
        return http.put(`${ApiConstants.URL.BASE}${ApiConstants.URL.EXPENSE.EXPENSES}/${id}`, payload).catch(
            (error) => {
                console.error('Error submitting expense: ', error);
                return Promise.reject(error);
            }
        );
    }

    static fetchClaimsSummary(id, payload) {
        return http.get(`${ApiConstants.URL.BASE}${ApiConstants.URL.EXPENSE.STATUS}`, payload).catch(
            (error) => {
                console.error('Error getting expense summary: ', error);
                return Promise.reject(error);
            }
        );
    }

    static fetchClaimsByStatus(payload) {
        return http.get(`${ApiConstants.URL.BASE}${ApiConstants.URL.EXPENSE.EXPENSES}`, payload).catch(
            (error) => {
                console.error('Error getting expense by status {}: ', payload, error);
                return Promise.reject(error);
            }
        );
    }
    
    static fetchClaimsCount(payload) {
        return http.get(`${ApiConstants.URL.BASE}${ApiConstants.URL.EXPENSE.EXPENSES}?${payload}`).catch(
            (error) => {
                console.error('Error getting expense by status {}: ', payload, error);
                return Promise.reject(error);
            }
        );
    }

    static exportExpenseClaims(config) {
        const queryParams = [];
        Object.keys(config.queryParams).map(param => queryParams.push(`${param}${config.queryParams[param]}`));

        return axios.create().request({
            withCredentials: true,
            baseURL: ApiConstants.URL.BASE,
            method: "GET",
            url: `v1/expenses/export-with-filter?query=${queryParams.join(',')}`,
            params: config.params,
            responseType: "blob"
        });
    }
}

export default ExpenseClaimListService;
